import { Loader2, Mail, Send } from "lucide-react"
import {  Table, TableBody, TableCell, TableHead, TableHeader, TableRow, Card, CardContent, CardHeader, CardTitle } from "@/components/ui"
import { UnifiedEmailRecord } from "@/types/emails";
import { StatusBadge } from './StatusBadge';
import { formatEmailDate } from './utils';
import { HoverPreview } from "./PreviewIcon";
import { Pagination } from '@/components/ui/pagination';
import { ActionsMenu } from "./ActionsMenu";
import { useState } from "react";
import { DetailsDialog } from "./DetailsDialog";

export const EmailsTables = ({
  emails,
  pagination,
  currentPage,
  onPageChange,
  loading
}: { 
  emails: UnifiedEmailRecord[],
  pagination?: any,
  currentPage?: number,
  onPageChange?: (page: number) => void,
  loading?: boolean,
}) => {
  const [selectedEmail, setSelectedEmail] = useState<UnifiedEmailRecord | null>(null)

  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Send className="h-5 w-5" />
            Sent Emails
          </CardTitle>
        </CardHeader>
        <CardContent className="pb-0">
          {loading ? (
            <div className="flex items-center justify-center py-20">
              <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
              <span className="ml-2 text-muted-foreground">Loading Emails...</span>
            </div>
          ) : emails?.length === 0 ? (
            <div className="text-center py-8">
              <Mail className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
              <p className="text-muted-foreground">No sent emails found</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Recipient</TableHead>
                    <TableHead>Subject</TableHead>
                    <TableHead>Preview</TableHead>
                    <TableHead>Status</TableHead>
                    <TableHead>Sent</TableHead>
                    <TableHead>Actions</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {emails?.map((email: UnifiedEmailRecord) => (
                    <TableRow key={email.id}>
                      <TableCell className="font-medium">
                        {email.recipient_email}
                      </TableCell>
                      <TableCell>
                        {email.type === 'sent' 
                          ? email.subject 
                          : (email.final_subject || email.generated_subject || email.content.split(' - ')[0])
                        }
                      </TableCell>
                      <TableCell>
                      <HoverPreview 
                          htmlContent={
                            email.type === 'sent' 
                              ? email.html_body || email.text_body || ''
                              : (email.final_html_body || email.generated_html_body || email.content)
                          } 
                        />
                      </TableCell>
                      <TableCell>
                        <StatusBadge type={email.status} />
                      </TableCell>
                      <TableCell>
                        {formatEmailDate(email.created_date)}
                      </TableCell>
                      <TableCell>
                        <ActionsMenu 
                          item={email}
                          type={email.type === 'sent' ? 'sent' : 'failed'}
                          setSelectedEmail={setSelectedEmail} 
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
          
          {/* Pagination */}
          {pagination && onPageChange && currentPage !== undefined && (
            <Pagination
              pagination={pagination}
              currentPage={currentPage}
              onPageChange={onPageChange}
              showInfo={true}
              loading={loading}
            />
          )}
        </CardContent>
      </Card>
      
      {/* Details Modal - only one instance */}
      {selectedEmail && (
        <DetailsDialog 
          jobData={selectedEmail} 
          isModalOpen={!!selectedEmail} 
          setIsModalOpen={(open) => setSelectedEmail(open ? selectedEmail : null)} 
        />
      )}
    </>
  )
}